import type { StateCreator } from "zustand";
import type { Store } from "@/lib/store";
import type { TerminalResult } from "@/lib/types";

export interface TerminalSlice {
  terminalOutputs: TerminalResult[];
  terminalExecute: (input: string) => void;
  terminalClear: () => void;
}

export const createTerminalSlice: StateCreator<Store, [], [], TerminalSlice> = (
  set,
  _get,
) => {
  return {
    terminalOutputs: [],
    terminalExecute: (input: string) => {
      const { execute } = _get();
      const result = execute(input);
      set((s: TerminalSlice) => ({
        terminalOutputs: [
          {
            id: Date.now(),
            command: input,
            result: result,
          },
          ...s.terminalOutputs,
        ],
      }));
    },
    terminalClear: () => {
      return set((_s: TerminalSlice) => ({
        terminalOutputs: [],
      }));
    },
  };
};
